<template>
  <Dropdown v-if="isMobile">
    <template #activator="{ toggleDropdownVisibility }">
      <Btn
        :size="BtnSize.LG"
        :variant="BtnVariant.OUTLINED"
        class="text-on-background-variant"
        :class="{ 'w-full': fullWidthOnMobile }"
        @click="toggleDropdownVisibility"
      >
        {{ currentItem.label }}
        <Icon class="ml-2" :icon="ArrowDownSvg" />
      </Btn>
    </template>
    <template #default>
      <NuxtLink
        v-for="(item, itemIndex) in prevItems"
        :key="itemIndex"
        :to="item.to"
        class="h-9 px-4 flex items-center text-on-surface"
      >
        {{ item.label }}
      </NuxtLink>
    </template>
  </Dropdown>

  <nav v-else aria-label="breadcrumbs">
    <ol class="inline-flex border rounded-xl">
      <li
        v-for="(item, itemIndex) in props.items"
        :key="itemIndex"
        class="flex items-center"
      >
        <NuxtLink
          :to="item.to"
          class="h-10 px-4 flex items-center justify-center text-on-background-variant breadcrumb-element"
        >
          {{ item.label }}
        </NuxtLink>
        <Icon
          v-if="itemIndex < items.length - 1"
          :icon="ArrowRightSquareSvg"
          class="text-on-background-variant"
        />
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import { NuxtLink } from '#components';
import { Icon } from '~/components/icon';
import { Dropdown } from '~/components/dropdown';
import ArrowRightSquareSvg from '~/assets/icons/arrow-right-square.svg?component';
import ArrowDownSvg from '@/assets/icons/arrow-down.svg?component';
import { Btn, BtnSize, BtnVariant } from '~/components/btn';
import { useIsMobile } from '~/composables/use-is-mobile';

type Props = {
  items: { label: string; to: RouteLocationRaw }[];
  fullWidthOnMobile?: boolean;
};
const props = defineProps<Props>();

const isMobile = useIsMobile();

const currentItem = computed(() => {
  return props.items.at(-1);
});
const prevItems = computed(() => props.items.slice(0, -1));
</script>

<style scoped>
@reference "../../assets/css/main.css";

.breadcrumb-element.router-link-exact-active {
  @apply text-on-background;
}
</style>
